// Code generated by scripts/gen-sdk-validate from internal/validate; DO NOT EDIT.
// Run `task validate:sync` to regenerate. CI gates this file (git diff --exit-code).
//
// The key/prefix length caps + charset the data API enforces. If the SDK's
// copy drifts below the server's, data the server accepted becomes
// unretrievable via the SDK (a client-side invalid_key on read).

export const MAX_KEY_LEN = 256;
export const MAX_PREFIX_LEN = 256;

// The data-key / prefix charset (alphanumerics + '-' '.' '_' '~', the RFC 3986
// unreserved set), generated from internal/validate.KeyCharsetPattern — pinned equal
// to the server's isKeyRune predicate by TestKeyCharsetPatternMatchesPredicate.
export const KEY_RE = /^[A-Za-z0-9._~-]+$/;
